import ReactOnRails from 'react-on-rails';
import { reportWebVitals } from 'src/helpers/reportWebVitals';
import { reportGoogleTranslate } from 'src/utils/reportGoogleTranslate/reportGoogleTranslate';
import PackageCheckout from '../routes/Checkout/CheckoutRoutes/PackageCheckout';
import '../styles/pages/checkout_page.scss';

ReactOnRails.register({ PackageCheckout });

reportWebVitals();

reportGoogleTranslate();
